import { AxiosError } from "axios";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";

import { APPLICATION_TYPE, PRODUCT_DOMAIN } from "@/constants";
import axioInstance from "@/libs/axios";
import { useLoading } from "@/providers/loading-provider";
import { RootState } from "@/store/root-reducer";
import { OptionalExtra } from "@/types/OptionalExtraType";
import { QuoteData } from "@/types/quote/quote-data";
import logError from "@/utils/logger";

type QuoteResponse = {
  data: {
    data: QuoteData;
  };
};

// Custom hook for ACO data updating
export default function useUpdateAcoData() {
  const [data, setData] = useState<null | QuoteData>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<null | AxiosError>(null);

  const { version, referenceId } = useSelector(
    (state: RootState) => state.quote
  );
  const { showLoading, hideLoading } = useLoading();

  const updateAcoData = useCallback(
    async (requestdata: OptionalExtra[], isShowLoading = true) => {
      const postBody = {
        data: {
          type: APPLICATION_TYPE,
          channel: "ONLINE",
          version,
          attributes: {
            domain: PRODUCT_DOMAIN,
            priceResult: {
              optionalExtras: requestdata,
            },
          },
        },
      };

      if (isShowLoading) {
        showLoading();
      }

      try {
        const response: QuoteResponse = await axioInstance.patch(
          `${process.env.NEXT_PUBLIC_BASE_URL}/quote/${referenceId}/updateOptionalExtras`,
          postBody
        );
        setData(response.data.data);
      } catch (err) {
        const axiosError = err as AxiosError;
        logError(axiosError, { location: "Quote ACO Update" });
        setError(axiosError);
      } finally {
        setLoading(false);
        // resetTrigger();
        hideLoading();
      }
    },
    [version, referenceId, showLoading, hideLoading]
  );

  return { data, loading, error, updateAcoData };
}
